<template lang="pug">
  div.mb-1
    //- pre {{ value }}
    small.invalid.text-right(v-if="value.$dirty == true && value.required == false") {{ $t("error.isRequired", { fname: name }) }}
    small.invalid.text-right(v-if="value.$dirty == true && value.minLength == false") {{ $t("error.isMinLength", { fname: name, fvalue: value.$params.minLength.min }) }}
    small.invalid.text-right(v-if="value.$dirty == true && value.maxLength == false") {{ $t("error.isMaxLength", { fname: name, fvalue: value.$params.maxLength.max }) }}
    small.invalid.text-right(v-if="value.$dirty == true && value.minValue == false") {{ $t("error.isMinValue", { fname: name, fvalue: value.$params.minValue.min }) }}
    small.invalid.text-right(v-if="value.$dirty == true && value.maxValue == false") {{ $t("error.isMaxValue", { fname: name, fvalue: value.$params.maxValue.max }) }}
    small.invalid.text-right(v-if="value.$dirty == true && value.alpha == false") {{ $t("error.isAlpha", { fname: name }) }}
    small.invalid.text-right(v-if="value.$dirty == true && value.alphaNum == false") {{ $t("error.isAlphaNum", { fname: name }) }}
    small.invalid.text-right(v-if="value.$dirty == true && value.numeric == false") {{ $t("error.isNumeric", { fname: name }) }}
    small.invalid.text-right(v-if="value.$dirty == true && value.email == false") {{ $t("error.isEmail", { fname: name }) }}
    small.invalid.text-right(v-if="value.$dirty == true && value.ipAddress == false") {{ $t("error.isIpAddress", { fname: name }) }}
    small.invalid.text-right(v-if="value.$dirty == true && value.sameAs == false") {{ $t("error.isSameAs", { fname: name, fname2: name2 }) }}
    small.invalid.text-right(v-if="value.$dirty == true && value.notSameAs == false") {{ $t("error.notSameAs", { fname: name, fname2: name2 }) }}
    small.invalid.text-right(v-if="value.$dirty == true && value.url == false") {{ $t("error.isUrl", { fname: name }) }}
    small.invalid.text-right(v-if="value.$dirty == true && value.containAlphaNum == false") {{ $t("error.containAlphaNum", { fname: name }) }}
    small.invalid.text-right(v-if="value.$dirty == true && value.selectOption == false") {{ $t("error.selectOption", { fname: name }) }}
</template>

<script>
export default {
  props: {
    value: {
      type: Object
    },
    name: {
      type: String
    },
    name2: {
      type: String
    }
  }
};
</script>

<style lang="scss" scoped>
.invalid {
  display: block;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #f86c6b;
}
</style>
